<script lang="ts">
  import { CarouselSize, type Page } from "$lib/gql/genCms/codegen";
  import LandingPageContent from "$lib/components/LandingPageContent/LandingPageContent.svelte";
  import RecommendationCarousel from "$lib/components/Nosto/RecommendationCarousel.svelte";
  import ExtendedFooter from "$lib/components/Footer/ExtendedFooter.svelte";
  import DashSocialGallery from "$lib/components/DashSocial/DashSocialGallery.svelte";

  import cfg from "$lib/config/config";

  export let pageData: Page;
</script>

<LandingPageContent {pageData} />
<RecommendationCarousel
  pageType="HOME"
  input={{ placement: "frontpage-nosto-1" }}
  carouselSize={CarouselSize.Six}
/>

<DashSocialGallery
  galleryId={+cfg.HOME_PAGE_DASH_SOCIAL}
  title="Our Community In Belstaff"
/>
<ExtendedFooter />
